import React from 'react'
import styled from 'styled-components'
import { financeColors } from '../tokens'

interface Props {
  label: React.ReactNode
  value: React.ReactNode
  emphasis?: boolean
}

const Label = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${financeColors.textMuted};
  margin-bottom: 6px;
`

const Value = styled.div<{ $emphasis: boolean }>`
  color: ${financeColors.text};
  font-size: ${(props) => (props.$emphasis ? '16px' : '14px')};
  font-weight: ${(props) => (props.$emphasis ? 700 : 600)};
  min-height: 20px;
`

const FinanceInfoItem: React.FC<Props> = ({
  label,
  value,
  emphasis = false,
}) => (
  <div>
    <Label>{label}</Label>
    <Value $emphasis={emphasis}>{value}</Value>
  </div>
)

export default FinanceInfoItem
